import React, {useEffect, useState} from "react";
import {Box, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {displayFont} from "../../styling/GlobalTheme";

/* Compte à rebours jusqu'au départ (9h00 le premier jour). */
export default function Countdown({target}: { target: Date }) {
    const {i18n} = useTranslation();
    const de = i18n.language?.startsWith("de");
    const [now, setNow] = useState(Date.now());
    useEffect(() => { const t = setInterval(() => setNow(Date.now()), 1000); return () => clearInterval(t); }, []);
    const start = new Date(target); start.setHours(9, 0, 0, 0);
    const diff = Math.max(0, +start - now) / 1000;
    const parts = [
        [Math.floor(diff / 86400), de ? "Tage" : "jours"],
        [Math.floor(diff % 86400 / 3600), de ? "Std." : "heures"],
        [Math.floor(diff % 3600 / 60), "min"],
        [Math.floor(diff % 60), de ? "Sek." : "sec"],
    ] as const;
    if (diff <= 0) return null;
    return (
        <Box sx={{display: "flex", gap: {xs: .8, sm: 1.5}, my: 4, justifyContent: {xs: "center", md: "flex-start"}}} aria-label="Compte à rebours">
            {parts.map(([v, label]) => (
                <Box key={label} sx={{
                    minWidth: {xs: 60, sm: 82}, px: {xs: 1, sm: 1.5}, py: 1.2, textAlign: "center", borderRadius: 3,
                    bgcolor: "rgba(255,255,255,.12)", border: "1px solid rgba(255,255,255,.25)", backdropFilter: "blur(8px)",
                }}>
                    <Typography sx={{fontFamily: displayFont, fontSize: {xs: "1.9rem", sm: "2.6rem"}, lineHeight: 1}}>
                        {String(v).padStart(2, "0")}
                    </Typography>
                    <Typography sx={{fontSize: ".7rem", textTransform: "uppercase", letterSpacing: 1, opacity: .8}}>{label}</Typography>
                </Box>
            ))}
        </Box>
    );
}
